

export function Services () {
    return (
        <section id="services">
            <div className="container">
            <div className="section-head reveal">
                <div className="eyebrow">What we build</div>
                <h2>
                One team. Four disciplines.
                <br />
                Zero handoff friction.
                </h2>
                <p>From the AI layer to the infrastructure underneath, every system we ship is designed to talk to the next one.</p>
            </div>
            <div className="grid-4">
                <div className="card reveal">
                <div className="icon-box">
                    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2v4M12 18v4M4 12H2M22 12h-2M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2" />
                    <circle cx="12" cy="12" r="5" />
                    </svg>
                </div>
                <h3>AI Solutions</h3>
                <p>Custom models, agents, and copilots embedded directly into your workflows — not bolted on top of them.</p>
                <span className="tag">01 / AUTOMATION LAYER</span>
                </div>
                <div className="card reveal delay-1">
                <div className="icon-box">
                    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="7" height="7" rx="1" />
                    <rect x="14" y="3" width="7" height="7" rx="1" />
                    <rect x="14" y="14" width="7" height="7" rx="1" />
                    <rect x="3" y="14" width="7" height="7" rx="1" />
                    </svg>
                </div>
                <h3>ERP &amp; Odoo</h3>
                <p>Implementation, customization, and migration for the systems that run your operations end to end.</p>
                <span className="tag">02 / OPERATIONS LAYER</span>
                </div>
                <div className="card reveal delay-2">
                <div className="icon-box">
                    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 18 22 12 16 6" />
                    <polyline points="8 6 2 12 8 18" />
                    </svg>
                </div>
                <h3>Web Development</h3>
                <p>High-performance web apps and product interfaces, engineered with the same rigor as the backend.</p>
                <span className="tag">03 / EXPERIENCE LAYER</span>
                </div>
                <div className="card reveal delay-3">
                <div className="icon-box">
                    <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
                    </svg>
                </div>
                <h3>Cloud &amp; DevOps</h3>
                <p>Infrastructure, CI/CD, and observability so what you ship on Friday still works on Monday.</p>
                <span className="tag">04 / INFRASTRUCTURE LAYER</span>
                </div>
            </div>
            </div>
        </section>
    )
}